/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "../ColorsProvider";
import prefixStyles, { type StylesObject } from "../utils/prefixStyles";
import NumericUpDownPicker from "./NumericUpDownPicker";

type Props = {
  value: number,
  min: number,
  max: number,
  step: number,
  label?: ?React.Node,
  onDown?: ?() => void,
  onUp?: ?() => void,
  style?: ?StylesObject,
  unit?: ?string,
  valueStyle?: ?StylesObject,
  upButtonStyle?: ?StylesObject,
  downButtonStyle?: ?StylesObject,
  isHeat?: ?boolean,
  isCool?: ?boolean,
  "aria-controls"?: ?string,
  colors: ColorSet,
  isSidePicker?: ?boolean,
};

class DumbPivotNumericUpDownPicker extends React.Component<Props> {
  static defaultProps = {
    step: 1,
    isSidePicker: false,
    min: 55,
    max: 99,
    value: 70,
  };

  render() {
    const {
      value,
      min,
      max,
      step,
      label,
      onDown,
      onUp,
      style,
      unit,
      valueStyle,
      upButtonStyle,
      downButtonStyle,
      isHeat,
      isCool,
      "aria-controls": ariaControls,
      colors,
      isSidePicker,
    } = this.props;
    const styles = {
      wrapper: {
        outline: "none",
        margin: "0.3em 0.3em 0.3em 0.3em",
        ...style,
      },
      label: prefixStyles({
        color: colors.LABEL,
        fontSize: 16,
        userSelect: "none",
      }),
      controlsWrapper: prefixStyles({
        display: "flex",
      }),
      value: prefixStyles({
        fontSize: 35,
        userSelect: "none",
        ...valueStyle,
      }),
    };

    const valueDisplay = () => {
      return (
        <span style={styles.value}>
          {value}
          {unit || null}
        </span>
      );
    };

    return (
      <div
        data-component-name="PivotNumericUpDownPicker"
        tabIndex="0"
        style={styles.wrapper}
      >
        <div style={styles.controlsWrapper}>
          {isSidePicker ? valueDisplay() : null}
          <NumericUpDownPicker
            onUp={onUp}
            onDown={onDown}
            upDisabled={value + step > max}
            downDisabled={value - step < min}
            upButtonStyle={upButtonStyle}
            downButtonStyle={downButtonStyle}
            label={label}
            isHeat={isHeat}
            isCool={isCool}
            aria-controls={ariaControls}
            style={style}
          >
            {isSidePicker ? null : valueDisplay()}
          </NumericUpDownPicker>
        </div>
      </div>
    );
  }
}

export default withColorsProvider(DumbPivotNumericUpDownPicker);



// WEBPACK FOOTER //
// ../nx-components/src/PivotNumericUpDownPicker/DumbPivotNumericUpDownPicker.jsx